import React, { createContext } from 'react';

export const DatoTecnicoContext = createContext();